module.exports = __webpack_public_path__ + "static/media/CHAP02-OUVERTURE.3e320a9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP02-OUVERTURE.png
// module id = 296
// module chunks = 0